import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}


export const getEmployeeBalances = async (token: string, id: number, permission: string | null,
) => {
    const response = await axios.get(`${API_URL}/presenze/employee/${id}/balances/`, {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig);
    return response.data;
};

export const updateEmployeeBalance = async (token: string, employeeId: number, balanceId: number, value: number) => {
  const response = await axios.patch(`${API_URL}/presenze/employee/${employeeId}/balances/${balanceId}/`,
    {
      value: value
    }, {
      headers: {
        'Authorization': token,
      },
    }
  );
  return response.data;  
}; 
